import { Injector, Pipe, PipeTransform } from '@angular/core';
import { TableService } from '../services/table.service';

@Pipe({
    name: 'dtypeInjector',
    standalone: true
})
export class DtypeInjectorPipe implements PipeTransform {

	constructor(private tableService: TableService, private parentInjector: Injector) {}

	transform(dtype: string, element: any): Injector {
		return Injector.create({
			providers: [
				{
					provide: this.tableService.dtypeElement[this.tableService.getType(dtype, element.element)],
					useValue: element
				}
			],
			parent: this.parentInjector
		});
	}

}
